import type {
  StyleFunctionProps,
  StyleInterpolationMulti,
  StyleObjectMulti,
  StyleObjectNonMulti,
} from './types';

export const getStyleObjectFromStyleInterpolation = <
  StyleObjectType extends Record<string, unknown> | undefined,
  StyleFunctionPropsType,
>(
  styleInterpolation:
    | StyleObjectType
    | ((props: StyleFunctionPropsType) => StyleObjectType),
  styleFunctionProps: StyleFunctionPropsType,
): StyleObjectType => {
  const styleObject: StyleObjectType =
    typeof styleInterpolation === 'function'
      ? styleInterpolation(styleFunctionProps)
      : styleInterpolation;

  return styleObject;
};

export const getPartStyleFromStyleInterpolation = <
  PartType extends string,
  PartName extends PartType,
  VariantType extends string,
  ColorSchemeType extends string,
>(
  styleInterpolation:
    | StyleInterpolationMulti<PartType, VariantType, ColorSchemeType>
    | undefined,
  partName: PartName,
  styleFunctionProps: StyleFunctionProps<VariantType, ColorSchemeType>,
): StyleObjectNonMulti | undefined => {
  if (!styleInterpolation) {
    return undefined;
  }

  const styleObject: StyleObjectMulti<PartType> =
    getStyleObjectFromStyleInterpolation(
      styleInterpolation,
      styleFunctionProps,
    );

  return styleObject[partName];
};

export const getBaseStyleObjectFromStyleConfig = <
  StyleObjectType extends Record<string, unknown>,
  StyleFunctionPropsType,
>(
  styleConfig: {
    baseStyle?:
      | StyleObjectType
      | ((props: StyleFunctionPropsType) => StyleObjectType);
  },
  styleFunctionProps: StyleFunctionPropsType,
): StyleObjectType | undefined => {
  const baseStyle = styleConfig.baseStyle;

  const styleObject = getStyleObjectFromStyleInterpolation(
    baseStyle,
    styleFunctionProps,
  );

  return styleObject;
};
